const start = () => {
  const isAlreadyTracked = (link) => /([?&]WT\.mc_id=)|([?]utm_source=)/i.test(link.search);

  const domainNeedsTracking = (link, domains) =>
    domains.some((d) => {
      if (d instanceof RegExp) {
        return d.test(link.hostname);
      }
      if (typeof (d) === 'string') {
        return d === link.hostname;
      }
      return false;
    });

  const appendTrackingInfo = (config, links) => {
    const needsTracking =
      links.filter(l => domainNeedsTracking(l, config.domains) && !isAlreadyTracked(l));

    for (const l of needsTracking) {
      const tracking = `WT.mc_id=${config.event}-${config.channel}-${config.alias}`;
      if (l.search) {
        l.search = `${l.search}&${tracking}`;
      } else {
        l.search = `?${tracking}`;
      }
    }
  };

  const cdaTracker = (config) => {
    const defaultDomains = [
      /^(devblogs|azure|developer|devops|learn|techcommunity|visualstudio)\.microsoft\.com$/,
      /(.*\.)?msdn\.com$/,
      /(.*\.)?visualstudio\.com$/,
      "www.microsoftevents.com",
      /(.*\.)?github\.com$/
    ];

    config.domains = defaultDomains;

    appendTrackingInfo(config, [].slice.call(document.getElementsByTagName('a')));
  };

  cdaTracker({
    event: 'dotnet',
    channel: '35129',
    alias: 'website'
  });
};

export default {
  start
};
